import { defineField } from '../fieldBuilder';

import type { RequestFieldDefinition } from '../types';

/** small-ups — registry field list. */
export const SMALL_UPS_FIELDS: readonly RequestFieldDefinition[] = [
  defineField(
    'small-ups',
    'requirements',
    0,
    'smallUpsManufacturer',
    'Manufacturer',
    'Manufacturer',
  ),
  defineField(
    'small-ups',
    'requirements',
    1,
    'smallUpsModel',
    'Model',
    'Model',
  ),
  defineField(
    'small-ups',
    'requirements',
    2,
    'powerSmallUpsDescription',
    'Description',
    'Description',
  ),
  defineField(
    'small-ups',
    'requirements',
    3,
    'smallUpsSerialNumber',
    'Serial Number',
    'Serial',
  ),
  defineField(
    'small-ups',
    'requirements',
    4,
    'powerTypesOfUps',
    'Type of UPS',
    'Type',
  ),
  defineField(
    'small-ups',
    'requirements',
    5,
    'smallUpsInputVoltage',
    'Input Voltage',
    'Voltage',
  ),
  defineField(
    'small-ups',
    'requirements',
    6,
    'smallUpsInputPlug',
    'Input Plug',
    'Plug',
  ),
  defineField(
    'small-ups',
    'requirements',
    7,
    'powerInputPowerPhase',
    'Phases',
    'Phases',
  ),
  defineField(
    'small-ups',
    'requirements',
    8,
    'smallUpsCapacity',
    'UPS capacity in kVA',
    'UPS capacity in kVA',
  ),
  defineField(
    'small-ups',
    'requirements',
    9,
    'smallUpsLoadPercentage',
    'Load Percentage',
    'Load %',
  ),
  defineField(
    'small-ups',
    'requirements',
    10,
    'smallUpsExpectedLoadGrowth',
    'Expected Load Growth',
    'Load growth',
  ),
  defineField(
    'small-ups',
    'requirements',
    11,
    'smallUpsLoadOnGenerator',
    'Will load be on generator?',
    'Load on gen',
  ),
  defineField(
    'small-ups',
    'requirements',
    12,
    'powerRuntime',
    'Battery Runtime',
    'Runtime',
  ),
  defineField(
    'small-ups',
    'requirements',
    13,
    'smallUpsBatteryCabinetQty',
    'Quantity of Battery Cabinets',
    'Battery cabs',
  ),
  defineField(
    'small-ups',
    'requirements',
    14,
    'smallUpsMounting',
    'Mounting (2 or 4 post)',
    'Mounting',
  ),
  defineField(
    'small-ups',
    'requirements',
    15,
    'smallUpsMountType',
    'Mount Type',
    'Mount Type',
  ),
  defineField(
    'small-ups',
    'requirements',
    16,
    'smallUpsOutlets',
    'Number of Outlets (Quantity of controllable / always on)',
    'Outlets',
  ),
  defineField(
    'small-ups',
    'requirements',
    17,
    'smallUpsMaintenanceBypassRequired',
    'Maintenance bypass required',
    'Bypass',
  ),
  defineField(
    'small-ups',
    'requirements',
    18,
    'smallUpsBackupGenerator',
    'Backup Generator (Y/N)',
    'Generator',
  ),
  defineField(
    'small-ups',
    'requirements',
    19,
    'smallUpsRequiredSensors',
    'What sensors are required',
    'Sensors',
  ),
  defineField(
    'small-ups',
    'additionalInformation',
    0,
    'powerSmallUpsAdditionalInfo',
    'Additional Small UPS Info',
    'Notes',
  ),
];
